function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Quill from 'quill';
const Link = Quill.import('formats/link');
const Clipboard = Quill.import('modules/clipboard');
export function replaceNbsp(html) {
  return html.replace(/&nbsp;|\u00A0/g, ' ');
}
class ClipboardWithNbspFix extends Clipboard {
  onPaste(range, data) {
    if (data.html) {
      data.html = replaceNbsp(data.html);
    }
    super.onPaste(range, data);
  }
}
Quill.register('modules/clipboard', ClipboardWithNbspFix, true);
class CustomLinkSanitizer extends Link {
  static sanitize(url) {
    // Run default sanitize method from Quill
    const sanitizedUrl = super.sanitize(url);

    // Blank is not a whitelisted URL based on protocol so let's short-circuit here
    if (!sanitizedUrl || sanitizedUrl === 'about:blank') return sanitizedUrl;

    // Verify whether the URL already has a whitelisted protocol
    const hasWhitelistedProtocol = this.PROTOCOL_WHITELIST.some(function (protocol) {
      return sanitizedUrl.startsWith("".concat(protocol, "://"));
    });
    if (hasWhitelistedProtocol) return sanitizedUrl;

    // if not, then prepend 'https' to force the URL to be absolute
    return "https://".concat(sanitizedUrl);
  }
}
_defineProperty(CustomLinkSanitizer, "PROTOCOL_WHITELIST", ['http', 'https', 'mailto', 'tel', 'sms']);
Quill.register('formats/link', CustomLinkSanitizer, true);
(function installNbspFix() {
  // Get the original method that *every* Quill instance inherits
  const original = Quill.prototype.getSemanticHTML;

  // ugly patch to fix the issue with &nbsp; in Quill
  Quill.prototype.getSemanticHTML = function () {
    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let length = arguments.length > 1 ? arguments[1] : undefined;
    const len = length !== null && length !== void 0 ? length : this.getLength();
    const html = original.call(this, index, len);
    return replaceNbsp(html);
  };
})();
export { Quill };